module.exports = __webpack_public_path__ + "img/vertical_3_3_8019.ae7e752f.png";